import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

interface Props {
  children: React.ReactNode;
  link: string;
}

const PageMoveText = ({ children, link }: Props) => {
  const handleClickMove = () => {
    window.location.href = link;
  };

  return <Container onClick={handleClickMove}>{children}</Container>;
};

export default PageMoveText;
